import UpdateReinsuredForm from 'components/features/update-reinsured-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function UpdateReinsured() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('reinsured.reinsuredRecords')}>
      <UpdateReinsuredForm />
    </HomeLayout>
  );
}

export default UpdateReinsured;
